import { ReactNode, createContext, useContext, useMemo } from 'react';

export type AutotestSlotName =
  | 'aboveHeader'
  | 'underHeader'
  | 'preCta'
  | 'underCta'
  | 'anchorChip';

export type LoginModalAutotestHooks = {
  slots?: Partial<Record<AutotestSlotName, ReactNode>>;
  wrapOnSuccess?: (
    navigate: (redirect?: string) => void,
  ) => (redirect?: string) => void;
  onClose?: () => void;
  ctaDefaultExpanded?: boolean;
};

// Distribution channel for the login_modal/autotest harness: the manager
// provides the hooks it resolved at modal open
const AutotestHooksContext = createContext<LoginModalAutotestHooks | undefined>(
  undefined,
);

export const AutotestHooksProvider = AutotestHooksContext.Provider;

export function useAutotestHooks(): LoginModalAutotestHooks | undefined {
  return useContext(AutotestHooksContext);
}

export function useAutotestSlot(name: AutotestSlotName): ReactNode {
  return useContext(AutotestHooksContext)?.slots?.[name];
}

export function useAutotestWrappedNavigate(
  navigate: (redirect?: string) => void,
): (redirect?: string) => void {
  const hooks = useContext(AutotestHooksContext);
  return useMemo(
    () => hooks?.wrapOnSuccess?.(navigate) ?? navigate,
    [hooks, navigate],
  );
}
